/* ==========================================================================
   nav-active.js — Current-page highlighting & related-hovered sibling logic
   Mirrors the live site's lib-utilities-anchors behavior.
   ========================================================================== */

(function () {
  'use strict';

  // --- current-page ---
  // Mark every <a> inside #wrap whose href matches the current path.

  function markCurrentPage() {
    var currentPath = window.location.pathname.replace(/\/$/, '') || '/';
    var wrap = document.getElementById('wrap');
    if (!wrap) return;

    wrap.querySelectorAll('a[href]').forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;
      var linkPath = href.split('?')[0].split('#')[0].replace(/\/$/, '') || '/';

      if (linkPath === currentPath) {
        link.classList.add('current-page');
      } else {
        link.classList.remove('current-page');
      }
    });
  }

  // --- related-hovered ---
  // When hovering a nav link, add "related-hovered" to its siblings in the
  // same <ul>/<nav> container so the current-page dimming rule is overridden.

  function findNavContainer(el) {
    var node = el.parentElement;
    while (node) {
      var tag = node.tagName;
      if (tag === 'UL' || tag === 'OL' || tag === 'NAV' || tag === 'FORM') return node;
      node = node.parentElement;
    }
    return null;
  }

  function getSiblingLinks(container, self) {
    if (!container) return [];
    var all = container.querySelectorAll('a[href]');
    var siblings = [];
    for (var i = 0; i < all.length; i++) {
      if (all[i] !== self) siblings.push(all[i]);
    }
    return siblings;
  }

  function onMouseEnter(e) {
    var link = e.target.closest('a[href]');
    if (!link) return;
    var container = findNavContainer(link);
    getSiblingLinks(container, link).forEach(function (s) {
      s.classList.add('related-hovered');
    });
  }

  function onMouseLeave(e) {
    var link = e.target.closest('a[href]');
    if (!link) return;
    var to = e.relatedTarget ? e.relatedTarget.closest('a[href]') : null;
    if (to === link) return;
    var container = findNavContainer(link);
    getSiblingLinks(container, link).forEach(function (s) {
      s.classList.remove('related-hovered');
    });
  }

  // Attach to header nav lists
  function bindHoverEvents() {
    document.querySelectorAll('.header__nav-list, .header__actions').forEach(function (list) {
      list.addEventListener('mouseenter', onMouseEnter, true);
      list.addEventListener('mouseleave', onMouseLeave, true);
    });
  }

  // Every navigation is a full page load, so markCurrentPage runs fresh on
  // each page and the highlight can't go stale.
  markCurrentPage();
  bindHoverEvents();
})();
